import React from "react";
import Footer from "../../components/Landing/Footer";
import Navbar from "../../components/Landing/LandingNavbar";
import policy from "../../constant/policy.json";

const ShippingAndDelivery = () => {
  return (
    <div>
      <Navbar />
      <div className="text-center my-6 space-y-4">
        <h1 className="text-5xl font-bold">
          <span className="text-my-blue"> Shipping And </span> Delivery
        </h1>
      </div>
      <div className="my-16 ">
        <div className="container space-y-2 mb-6">
          {/* <h2 className="font-bold text-xl ">Introduction</h2> */}
          <p className="font-light  text-my-gray3 text-base leading-5">
            Thank you for choosing Tootler.ai! We are delighted to provide you
            with an innovative Software-as-a-Service (SaaS) product that
            promises to enhance your productivity and efficiency. As a
            cloud-based software solution, Tootler.ai is distributed online and
            delivered immediately after purchase via electronic means to your
            Tootler Account. Here is everything you need to know about our
            shipping and delivery policy:
          </p>
        </div>

        <div className="container space-y-2 mb-6">
          <h2 className="font-bold text-xl "> Instant Delivery:</h2>

          <ul className="font-light text-my-gray3 text-base leading-5 ">
            <li>
              Tootler.ai is a digital product, and there is no physical shipping
              involved. Upon successful completion of your purchase, you will
              gain immediate access to the software. Once your payment is
              processed, you will receive an email notification with your
              account details and instructions on how to log in and get started.
            </li>
          </ul>
        </div>

        <div className="container space-y-2 mb-6">
          <h2 className="font-bold text-xl ">Digital Access:</h2>
          <p className="font-light  text-my-gray3 text-base leading-5">
            {" "}
            Your access to Tootler.ai will be granted through your personal
            Tootler Account, which is created during the purchase process. You
            can access the software via your preferred web browser on compatible
            devices, including but not limited to desktop computers, laptops,
            tablets, and smartphones.
          </p>
        </div>

        <div className="container space-y-2 mb-6">
          <h2 className="font-bold text-xl ">Account Setup:</h2>
          <p className="font-light  text-my-gray3 text-base leading-5">
            {" "}
            Tootler.ai will securely store your account information, including
            login credentials and any relevant subscription details. It is
            important to keep this information confidential to maintain the
            security of your account and data.
          </p>
        </div>

        <div className="container space-y-2 mb-6">
          <h2 className="font-bold text-xl ">Customer Support:</h2>
          <p className="font-light  text-my-gray3 text-base leading-5">
            {" "}
            Our team is dedicated to providing exceptional customer support. If
            you encounter any issues with the purchase process or accessing your
            Tootler Account, please dont hesitate to contact our support team
            through the provided channels on our website. We are available to
            assist you and resolve any concerns promptly.
          </p>
        </div>
        <div className="container space-y-2 mb-6">
          <h2 className="font-bold text-xl ">Subscription Renewals:</h2>
          <p className="font-light  text-my-gray3 text-base leading-5">
            {" "}
            For subscription-based plans, your access to Tootler.ai will be
            valid for the duration of the subscription period you have selected
            during the purchase. Prior to the expiration of your subscription,
            you will receive notifications regarding the upcoming renewal. You
            can choose to renew your subscription to continue enjoying
            uninterrupted access to the software and its features.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ShippingAndDelivery;
